"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsService = void 0;
var lodash_1 = require("lodash");
var translation_1 = __importDefault(require("./translation"));
var variables_const_1 = require("../variables.const");
var SettingsService = /** @class */ (function () {
    function SettingsService() {
        return new Proxy(this, {
            get: function (target, prop, receiver) {
                // If the property is specifically 'settings', return _settings directly.
                if (prop === 'settings') {
                    return target._settings;
                }
                // For all other properties, use the standard behavior.
                return Reflect.get(target, prop, receiver);
            },
            // You could also define a set trap if you need to handle assignments to properties.
            set: function (target, prop, value, receiver) {
                if (prop === 'settings') {
                    target._settings = value;
                    return true;
                }
                return Reflect.set(target, prop, value, receiver);
            },
        });
    }
    Object.defineProperty(SettingsService.prototype, "set", {
        set: function (value) {
            if (value === null || value === void 0 ? void 0 : value.defaultLanguage) {
                translation_1.default.changeLanguage(value.defaultLanguage);
            }
            var _settings = (0, variables_const_1._ConvertWebflowSettings)(value);
            this._settings = _settings;
        },
        enumerable: false,
        configurable: true
    });
    SettingsService.prototype.update = function (path, value) {
        (0, lodash_1.set)(this._settings, path, value);
    };
    Object.defineProperty(SettingsService.prototype, "get", {
        get: function () {
            return this._settings;
        },
        enumerable: false,
        configurable: true
    });
    return SettingsService;
}());
exports.SettingsService = SettingsService;
